import { useCallback, useState, useEffect } from "react";
import Main from "../../components/layouts/Main";
import PageTitle from "../../components/utils/PageTitle";
import Breadcrumb from "../../components/utils/Breadcrumb";
import { catchError } from "../../services/DaoService";
import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import {
  PlusCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import {EtapeService} from "../../services/EtapeService";
import EtapeCreateForm from "../../components/etape/EtapeCreateForm";
import EtapeList from "../../components/etape/EtapeList";
// import PropTypes from "prop-types";


export default function EtapeListPage() {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [statut, setStatut] = useState('tout');
  const [etapes, setEtapes] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    EtapeService.getInstance()
      .search({ searchText, statut })
      .then((response) => {
        setPaginationData(response.data);
        setEtapes(response.data.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchText, statut]);

  useEffect(() => {
    init();
  }, [init]);

  const handleCreation = () => {
    init();
  };

  const labelStyle = {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };
  return (
    <Main>
      <Breadcrumb
        parentLink="/settings"
        canSee={true}
        parentLinkTitle="Paramètrage"
        title="Etapes"
      />
      <PageTitle
        title="Liste des étapes"
        subTitle="Définir les différentes étapes de votre processus"
        icon={<PlusCircleFilled />}
      >
        <Button
            type="primary"
            icon={<PlusCircleFilled />}
            onClick={() => setNewModalVisible(true)}
          >
            Ajouter une étape
          </Button>
        <Button type="default" icon={<ReloadOutlined />} onClick={init}>
          Rafraîchir
        </Button>
      </PageTitle>
      <Card>
        <Row gutter={[16, 16]} justify={"center"}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Input.Search
              size="large"
              value={searchText}
              onInput={(e) => setSearchText(e.target.value)}
              placeholder="Rechercher par nom ou code"
            />
          </Col>
          <Col xs={24} md={8} lg={6}>
            <div style={containerStyle}>
              <div style={labelStyle}>Statut:</div>
              <Select size="large"
                value={statut}
                onChange={(value) => {
                  setStatut(value);
                }}
                placeholder="Filtrer par statut"
                style={{ width: "100%" }}
              >
                <Select.Option value="tout">Tous</Select.Option>
                <Select.Option value="actif">Activé</Select.Option>
                <Select.Option value="inactif">Désactivé</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <EtapeList etapes={etapes} setEtapes={setEtapes} paginationData={paginationData} setPaginationData={setPaginationData} searchText={searchText} />
        </Spin>
      </Card>

      <EtapeCreateForm
        visible={newModalVisible}
        onCreate={handleCreation}
        onCancel={() => setNewModalVisible(false)}
      />
    </Main>
  );
}


EtapeListPage.propTypes = {
    // renseigner les props du composant ici
};
